import React, { useState, useEffect } from "react";
import "../styles.css";
import { getCardImages, getCollectionStorage } from "../helpers";

export default function Collection() {
  // State to track the selected card
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedCardCount, setSelectedCardCount] = useState(null)
  // State to hold the card collection
  const [cardCollection, setCardCollection] = useState([]);

  useEffect(() => {
    // Load card collection from local storage
    const storedCollection = getCollectionStorage();
    setCardCollection(storedCollection)
  }, []);

  // Function to handle button click and update the selected card
  const handleCardClick = (cardImage, cardCount) => {
    setSelectedCardCount(cardCount);
    setSelectedCard(cardImage);
  };

  const imageNames = getCardImages();

  // Import the empty card image using require
  const emptyCard = require("../images/empty-card.png");

  // Dynamically import the images using require
  const cards = imageNames.map((imageName, index) => ({
    image: require(`../images/CardCollection/${imageName}`),
    count: cardCollection[index] ? cardCollection[index].count : 0
  }));

  return (
    <div className="collection-main">
      <div className="collection-specific-card">
        <div className="collection-counter-card">
          {selectedCardCount !== null ? (
            `You have ${selectedCardCount} ${selectedCardCount === 1 ? 'copy' : 'copies'} of this card`
          ) : (
            'Select a card'
          )}
        </div>
        <div className="collection-card-wrapper">
          <img src={selectedCard ? selectedCard : emptyCard} alt="card" />
        </div>
      </div>
      <div className="collection-cards">
        {/* Render buttons for different cards */}
        {cards.map((card, index) => (
          <button
            className="collection-button"
            key={index}
            onClick={() => handleCardClick(card.image, card.count)}
            disabled={card.count < 1}
          >
            {`Card ${index + 1}`}
          </button>
        ))}
      </div>
    </div>
  );
}
